import { ref, watch } from "vue";

export function useValidation() {
  const validationResult = ref([]);
  const fields = ref(0);
  const validate = ref(false);
  const canSubmit = ref(false);
  
  const checkFormValidation = () => {
    validate.value = true;
    canSubmit.value = false;
    validationResult.value = []; // Clear previous validation results
    
    setTimeout(() => {
      validate.value = false;
    }, 1500);
  };
  
  const handleValidation = (val) => {
    validationResult.value.push(val);
  };
  
  watch(
    validationResult,
    (value) => {
      if (value.length === fields.value && !value.includes(false)) {
        canSubmit.value = true;
      } else {
        canSubmit.value = false;
      }
    },
    { deep: true }
  );
  
  return {
    fields,
    checkFormValidation,
    handleValidation,
    validate,
    canSubmit,
  };
}